export default __webpack_public_path__ + "static/media/Fiori_di_magnolia_Cristina_Mavaracchio_30_x_40.cf16504c.jpg";